import { useQuery } from '@tanstack/react-query';

import { planManagementService } from '@/services/customer/plan-management.service';
import type { CustomerPlanManagementResponse } from '@/types/customer-plan-management';

export const customerPlanManagementKeys = {
  all: ['customer', 'plan-management'] as const,
  detail: () => [...customerPlanManagementKeys.all, 'detail'] as const,
  downgradeOptions: () => [...customerPlanManagementKeys.all, 'downgrade-options'] as const,
};

export function useCustomerPlanManagement() {
  return useQuery<CustomerPlanManagementResponse>({
    queryKey: customerPlanManagementKeys.detail(),
    queryFn: () => planManagementService.getPlanManagement(),
    staleTime: 30_000,
  });
}

export function useCustomerDowngradeOptions() {
  return useQuery({
    queryKey: customerPlanManagementKeys.downgradeOptions(),
    queryFn: () => planManagementService.getDowngradeOptions(),
    staleTime: 30_000,
  });
}
